/** Calculates the remaining vacation balance */
export const calcRemaining = (allowance, extra, used, satUsed, saturdaysCalculatedAsHoliday) => {
	const effectiveSatUsed = saturdaysCalculatedAsHoliday ? satUsed : 0
	return allowance + extra - used + effectiveSatUsed
}
